import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ErrorDialogComponent } from './ErrorDialog/ErrorDialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/@core/services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorDialogServiceService {

  private opened = false;

  constructor(private dialog: MatDialog, private notify: NotificationService) { }

  // openDialog(message: any, subErrors?: any[]): void {

  //   if (!this.opened) {
  //     this.opened = true;
  //     const dialogRef = this.dialog.open(ErrorDialogComponent, {
  //       data: { message, subErrors },
  //       maxHeight: "100%",
  //       width: "540px",
  //       maxWidth: "100%",
  //       disableClose: true,
  //       hasBackdrop: true
  //     });

  //     dialogRef.afterClosed().subscribe(() => {
  //       this.opened = false;
  //     });
  //   }
  // }


  openDialog(error: any, subErrors?: any[]): void {
    let errorMessage = '';

    console.log('Received error:', error); // ✅ Debugging line to see actual response

    // ✅ Handle HTTP Errors
    if (error instanceof HttpErrorResponse) {
      if (error.error) {
        if (typeof error.error === 'string') {
          errorMessage = error.error; // BE sent error as a simple string
        } else if (error.error.error) {
          errorMessage = error.error.error; // BE sent { error: "message" }
        } else if (error.error.message) {
          errorMessage = error.error.message; // BE sent { message: "error text" }
        } else {
          errorMessage = `Error ${error.status}: ${error.statusText}`;
        }
      } else {
        errorMessage = `Error ${error.status}: ${error.message}`;
      }
    }
    // ✅ Handle Non-HTTP Errors (e.g., JS Errors, Undefined Values)
    else if (typeof error === 'string' && error.trim() !== '') {
      errorMessage = error;
    }

    // ✅ Fallback Check: If errorMessage is still empty, use a generic message
    if (!errorMessage) {
      errorMessage = "An unexpected error occurred. Please try again.";
    }

    // ✅ Show the extracted error message in notification
    this.notify.showMessage(errorMessage, 10000);
  }

}
